export default __webpack_public_path__ + "static/media/en.659a2b18.PNG";